<app-popup-shot class="popup"
  [stats]="popupStats"
  [class.shown]="popupShown"
  [style.left.px]="popupLeft"
  [style.top.px]="popupTop"></app-popup-shot>
<div class="messagesWrapper">
  <ng-container *ngFor="let msg of lastMessages">
    <app-event-message *ngIf="msg.points && msg.player" [event]="msg"></app-event-message>
  </ng-container>
</div>
<div id="map" #map></div>
<!-- <div class="mapZoomControlWrapper">
  <div class="group">
    <div class="button" (click)="zoomIn()"><img src="/assets/img/icons/zoom-in.svg"></div>
    <div class="button" (click)="zoomOut()"><img src="/assets/img/icons/zoom-out.svg"></div>
  </div>
  <div class="button group" (click)="resetZoom()"><img src="/assets/img/icons/zoom-reset.svg"></div>
</div> -->
